import tippy from 'tippy.js';
import {$dom} from '../../helpers/dom';

export default function defaultTooltip(defaultSelector = '[data-tippy-content]', settings = {
	appendTo: 'parent',
	arrow: false
}) {


	const
		init = () => {
			tippy(defaultSelector, settings);
		},
		destroy = () => {
			$dom.callAll(defaultSelector, t => {
				t._tippy.destroy()
			})
		}
	;

	return {init, destroy}
}
